import React from "react";
import ReactDOM from "react-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import App from "./App";
import '@fortawesome/fontawesome-free/css/all.min.css'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import './style.css'

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Helmet prioritizeSeoTags>
        <meta
          property="og:title"
          content="Alfa Prima - Sistem Informasi Akademik"
        />
        <meta
          name="description"
          content="Sistem Informasi Akademik - Alfa Prima"
        />
      </Helmet>
      <Helmet>
        <body className="bg-light" />
      </Helmet>
    </HelmetProvider>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
